import { useTranslation } from "react-i18next";
import { coerceLocale } from "@jackedlogs/shared";
import { TargetsEditor } from "@jackedlogs/ui";

import { apiFetch } from "./api";
import { useAuth } from "./auth/AuthContext";
import { useSelfProgressDeps } from "./progress/progressDeps";

// Me → Goals on web-rnw (closes rnw-strangler §8): the athlete editing their OWN
// weekly targets, the web twin of mobile's MeTargetsScreen. The SAME shared
// <TargetsEditor> the coach mounts in AthleteDetailScreen, pointed at
// /api/me/targets (source={{}}) instead of an athlete's — same ETag write-lock,
// same server-authored history, different house. Web seams and only those: the
// base unscoped apiFetch (carries If-Match), the SELF deps sharing the one warm
// session-results cache with Progress, the caller's own sub from useAuth (no
// coach-edges fetch just to label my own edits), and onClose = the shell's
// "back to Me". The editor owns its EditorTopBar (back + title + Save), so the
// shell mounts this WITHOUT its meHead wrapper.
export function MeTargetsScreen({ onClose }: { onClose: () => void }) {
  const { t, i18n } = useTranslation();
  const { state } = useAuth();
  const callerSub = state.status === "signed_in" ? state.user.sub : null;
  const deps = useSelfProgressDeps();

  return (
    <TargetsEditor
      theme={deps.theme}
      apiFetch={apiFetch}
      deps={deps}
      source={{}}
      // On my own surface my edits are "You"; anyone else who moved my targets
      // did it through a granted coach edge.
      resolveAuthor={(bySub) =>
        callerSub !== null && bySub === callerSub
          ? t("coach.targets.historyByYou", { defaultValue: "You" })
          : t("me.targets.historyByCoach", { defaultValue: "Your coach" })
      }
      units={deps.units}
      weekStartDay={deps.weekStartDay}
      locale={coerceLocale(i18n.language)}
      backLabel={t("mobile.tabs.me", { defaultValue: "Me" })}
      onClose={onClose}
    />
  );
}
